import loadingImg from 'src/assets/images/loading.gif'
import { PageCallingWrap } from 'src/styles/styledcomponent/component/common'

const PageCalling = (props: { active: boolean }): JSX.Element => {
const { active } = props
  return (
    <PageCallingWrap active={active}>
      <div>
        <p>
          잠시만 기다려주세요
          <br />
          페이지를 불러오고 있습니다.
        </p>
        <img src={loadingImg} alt=' 로딩 이미지' />
      </div>
    </PageCallingWrap>
  )
}
export default PageCalling
